export const ARTICLE_AUDIT_REASON_CATEGORY_FLAGS = [
  {
    key: 'article_content_error',
    value: '記事内不備',
    text: '記事内不備',
    flags: [
      { key: 'text_error', value: '文字不備', text: '文字不備' },
      { key: 'image_error', value: '画像不備', text: '画像不備' },
      { key: 'invalid_link', value: '遷移先NG', text: '遷移先NG' },
      { key: 'submission_error', value: '入稿不備', text: '入稿不備' },
      { key: 'external_link_addition', value: '補足外リンク', text: '補足外リンク' },
    ],
  },
  {
    key: 'related_article',
    value: '関連記事',
    text: '関連記事',
    flags: [{ key: 'invalid_link', value: '遷移先NG', text: '遷移先NG' }],
  },
  {
    key: 'in_article_link',
    value: '記事内リンク',
    text: '記事内リンク',
    flags: [
      { key: 'invalid_link', value: '遷移先NG', text: '遷移先NG' },
      { key: 'external_link_addition', value: '補足外リンク', text: '補足外リンク' },
      { key: 'inducement_purchase', value: '誘導・購買', text: '誘導・購買' },
    ],
  },
  {
    key: 'theme',
    value: 'テーマ',
    text: 'テーマ',
    flags: [
      { key: 'adult_grotesque', value: 'アダルト・グロ', text: 'アダルト・グロ' },
      { key: 'summary', value: 'まとめ', text: 'まとめ' },
      { key: 'medical', value: '医療', text: '医療' },
      { key: 'controversial', value: '炎上懸念', text: '炎上懸念' },
      { key: 'no_supervision', value: '監修なし', text: '監修なし' },
      { key: 'timing_mismatch', value: '時期ずれ', text: '時期ずれ' },
      { key: 'duplicate', value: '重複', text: '重複' },
      { key: 'insufficient_info', value: '情報不足', text: '情報不足' },
      { key: 'credibility_concern', value: '信憑懸念', text: '信憑懸念' },
      { key: 'fiction_confusion', value: '創作混同', text: '創作混同' },
      { key: 'crime', value: '犯罪', text: '犯罪' },
      { key: 'incomplete', value: '未完結', text: '未完結' },
      { key: 'inducement_purchase', value: '誘導・購買', text: '誘導・購買' },
    ],
  },
  {
    key: 'title',
    value: 'タイトル',
    text: 'タイトル',
    flags: [
      { key: 'directive_masked_words', value: '指示語・伏字', text: '指示語・伏字' },
      { key: 'content_mismatch', value: '内容齟齬', text: '内容齟齬' },
    ],
  },
  {
    key: 'thumbnail',
    value: 'サムネイル',
    text: 'サムネイル',
    flags: [{ key: 'thumbnail_error', value: 'サムネイル不備', text: 'サムネイル不備' }],
  },
  {
    key: 'other',
    value: 'その他',
    text: 'その他',
    flags: [{ key: 'other', value: 'その他', text: 'その他' }],
  },
]

export const MEDIUM_RELATED_ARTICLE_RISK_MESSAGE = {
  isExternalDomainLink: 'ドメイン（ドメイン不一致）',
  isDeadLink: 'デッドリンク',
  isEcLink: 'EC（ECリンク）',
  isSurveyLink: 'アンケート（アンケートフォーム）',
  isMismatchTitle: 'タイトル（タイトル内容不一致）',
}
